import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { FieldType } from 'enums/FieldTypeEnums';
import { FieldsRowProps } from 'shared/components/FieldsRow';
import { allowOnlyNumbersUptoN } from 'shared/utils/convertFormData';
import {
  MANUAL_SCOPE3_CONSTANTS,
  SCOPE3_EMISSION_UNIT_OPTIONS,
} from 'constants/Scope3Constants/manualScope3Categories.constants';

const { INPUT, SELECT } = FieldType;
const {
  LABELS: { UNIT, TOTAL_EMISSIONS },
  FIELD_UNIT,
  FIELD_EMISSIONS,
  rowGutter,
  formType,
} = MANUAL_SCOPE3_CONSTANTS;

interface ManualEmissionLayoutDataProps {
  handleToolTipOpen: (fieldName: HelpDeskInputFieldEnum) => () => void;
  helpdeskKey: HelpDeskInputFieldEnum;
  readOnly?: boolean;
}

export const getManualEmissionFieldsData = (
  props: ManualEmissionLayoutDataProps
): FieldsRowProps => {
  const { handleToolTipOpen, helpdeskKey, readOnly } = props;
  const disabled = !!readOnly;

  return {
    rowGutter,
    formType,
    data: [
      {
        type: INPUT,
        span: 7,
        fieldProps: {
          name: FIELD_EMISSIONS,
          label: TOTAL_EMISSIONS,
          placeholderstring: TOTAL_EMISSIONS,
          isNullable: true,
          info: true,
          infoClick: handleToolTipOpen(helpdeskKey),
          onKeyDown: allowOnlyNumbersUptoN(4),
          disabled,
        },
      },
      {
        type: SELECT,
        span: 4,
        fieldProps: {
          name: FIELD_UNIT,
          options: SCOPE3_EMISSION_UNIT_OPTIONS,
          label: UNIT,
          placeholderstring: UNIT,
          disabled,
        },
      },
    ],
  };
};
